// third-party
import { FormattedMessage } from 'react-intl';

export const departments =  [
    {
        title: <FormattedMessage id="departments.healthandpersonalcare" defaultMessage="Health and Personal Care" />,
        url: '',
        submenu: {
            type: 'megamenu',
            menu: {
                size: 'xl',
                columns: [
                    {
                        size: 3,
                        links: [
                            {
                                title: <FormattedMessage id="departments.personalcare" defaultMessage="Personal Care" />,
                                url: '/shop/catalog/personal-care',
                                links: [
                                    { title: <FormattedMessage id="departments.haircare" defaultMessage="Hair Care" />, url: '/shop/catalog/hair-care' },
                                    { title: <FormattedMessage id="departments.oralcare" defaultMessage="Oral Care" />, url: '/shop/catalog/oral-care' },
                                    { title: <FormattedMessage id="departments.skincare" defaultMessage="Skin Care" />, url: '/shop/catalog/skin-care' },
                                    { title: <FormattedMessage id="departments.bathandbody" defaultMessage="Bath & Body" />, url: '/shop/catalog/bath-body' },
                                    { title: <FormattedMessage id="departments.shavingandgrooming" defaultMessage="Shaving & Grooming" />, url: '/shop/catalog/shaving-grooming' },
                                ],
                            },
                            { 
                                title: <FormattedMessage id="departments.vitaminsandsupplements" defaultMessage="Vitamins & Supplements" />, 
                                url: '/shop/catalog/vitamins-supplements', 
                                links: [] 
                            },
                            { 
                                title: <FormattedMessage id="departments.healthdevices" defaultMessage="Health Devices" />, 
                                url: '/shop/catalog/health-devices', 
                                links: [] 
                            },
                            { 
                                title: <FormattedMessage id="departments.firstaid" defaultMessage="First Aid" />, 
                                url: '/shop/catalog/first-aid', 
                                links: [] 
                            },
                            { 
                                title: <FormattedMessage id="departments.eyecare" defaultMessage="Eye Care" />, 
                                url: '/shop/catalog/eye-care', 
                                links: [] 
                            },
                        ],
                    },
                    {
                        size: 3,
                        links: [
                            {
                                title: <FormattedMessage id="departments.medicalsupplies" defaultMessage="Medical Supplies" />,
                                url: '/shop/catalog/medical-supplies',
                                links: [
                                    { title: <FormattedMessage id="departments.bracesandsupports" defaultMessage="Braces & Supports" />, url: '/shop/catalog/braces-supports' },
                                    { title: <FormattedMessage id="departments.mobilityaids" defaultMessage="Mobility Aids" />, url: '/shop/catalog/mobility-aids' },
                                    { title: <FormattedMessage id="departments.bandagesanddressings" defaultMessage="Bandages & Dressings" />, url: '/shop/catalog/bandages-dressings' },
                                    { title: <FormattedMessage id="departments.thermometers" defaultMessage="Thermometers" />, url: '/shop/catalog/thermometers' },
                                ],
                            },
                            {
                                title: <FormattedMessage id="departments.babyhealth" defaultMessage="Baby Health" />,
                                url: '/shop/catalog/baby-health',
                                links: [
                                    { title: <FormattedMessage id="departments.diapers" defaultMessage="Diapers" />, url: '/shop/catalog/diapers' },
                                    { title: <FormattedMessage id="departments.babyskincare" defaultMessage="Baby Skincare" />, url: '/shop/catalog/baby-skincare' },
                                    { title: <FormattedMessage id="departments.babymedicine" defaultMessage="Baby Medicine" />, url: '/shop/catalog/baby-medicine' },
                                ],
                            },
                        ],
                    },
                    {
                        size: 3,
                        links: [
                            {
                                title: <FormattedMessage id="departments.fitnessandwellness" defaultMessage="Fitness & Wellness" />,
                                url: '/shop/catalog/fitness-wellness',
                                links: [
                                    { title: <FormattedMessage id="departments.yogapilates" defaultMessage="Yoga & Pilates" />, url: '/shop/catalog/yoga-pilates' },
                                    { title: <FormattedMessage id="departments.weighttraining" defaultMessage="Weight Training" />, url: '/shop/catalog/weight-training' },
                                    { title: <FormattedMessage id="departments.cardioequipment" defaultMessage="Cardio Equipment" />, url: '/shop/catalog/cardio-equipment' },
                                ],
                            },
                        ],
                    },
                    {
                        size: 3,
                        links: [
                            {
                                title: <FormattedMessage id="departments.diagnosticsandtesting" defaultMessage="Diagnostics & Testing" />,
                                url: '/shop/catalog/diagnostics-testing',
                                links: [
                                    { title: <FormattedMessage id="departments.bloodpressuremonitors" defaultMessage="Blood Pressure Monitors" />, url: '/shop/catalog/blood-pressure-monitors' },
                                    { title: <FormattedMessage id="departments.glucosemonitors" defaultMessage="Glucose Monitors" />, url: '/shop/catalog/glucose-monitors' },
                                    { title: <FormattedMessage id="departments.heartratemonitors" defaultMessage="Heart Rate Monitors" />, url: '/shop/catalog/heart-rate-monitors' },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
    },
    
    {
        title: <FormattedMessage id="departments.homandkitchen" defaultMessage="Home and Kitchen" />,
        url: "/shop/catalog/home-and-kitchen",
        submenu: {
            type: "megamenu",
            menu: {
                size: "lg",
                columns: [
                    {
                        size: 4,
                        links: [
                            {
                                title: <FormattedMessage id="departments.kitchenappliances" defaultMessage="Kitchen Appliances" />,
                                url: "/shop/catalog/kitchen-appliances",
                                links: [
                                    { title: <FormattedMessage id="departments.blenders" defaultMessage="Blenders" />, url: "/shop/catalog/blenders" },
                                    { title: <FormattedMessage id="departments.microwaves" defaultMessage="Microwaves" />, url: "/shop/catalog/microwaves" },
                                    { title: <FormattedMessage id="departments.ovens" defaultMessage="Ovens" />, url: "/shop/catalog/ovens" },
                                    { title: <FormattedMessage id="departments.toasters" defaultMessage="Toasters" />, url: "/shop/catalog/toasters" }
                                ]
                            },
                            {
                                title: <FormattedMessage id="departments.cookware" defaultMessage="Cookware" />,
                                url: "/shop/catalog/cookware",
                                links: [
                                    { title: <FormattedMessage id="departments.potsandpans" defaultMessage="Pots & Pans" />, url: "/shop/catalog/pots-pans" },
                                    { title: <FormattedMessage id="departments.cookingutensils" defaultMessage="Cooking Utensils" />, url: "/shop/catalog/cooking-utensils" },
                                    { title: <FormattedMessage id="departments.bakingtools" defaultMessage="Baking Tools" />, url: "/shop/catalog/baking-tools" },
                                    { title: <FormattedMessage id="departments.pressurecookers" defaultMessage="Pressure Cookers" />, url: "/shop/catalog/pressure-cookers" }
                                ]
                            }
                        ]
                    },
                    {
                        size: 4,
                        links: [
                            {
                                title: <FormattedMessage id="departments.homeorganization" defaultMessage="Home Organization" />,
                                url: "/shop/catalog/home-organization",
                                links: [
                                    { title: <FormattedMessage id="departments.storagebins" defaultMessage="Storage Bins" />, url: "/shop/catalog/storage-bins" },
                                    { title: <FormattedMessage id="departments.closetorganizers" defaultMessage="Closet Organizers" />, url: "/shop/catalog/closet-organizers" },
                                    { title: <FormattedMessage id="departments.shelvingunits" defaultMessage="Shelving Units" />, url: "/shop/catalog/shelving-units" },
                                    { title: <FormattedMessage id="departments.laundrybaskets" defaultMessage="Laundry Baskets" />, url: "/shop/catalog/laundry-baskets" }
                                ]
                            },
                            {
                                title: <FormattedMessage id="departments.homedecor" defaultMessage="Home Decor" />,
                                url: "/shop/catalog/home-decor",
                                links: [
                                    { title: <FormattedMessage id="departments.wallart" defaultMessage="Wall Art" />, url: "/shop/catalog/wall-art" },
                                    { title: <FormattedMessage id="departments.rugs" defaultMessage="Rugs" />, url: "/shop/catalog/rugs" },
                                    { title: <FormattedMessage id="departments.curtains" defaultMessage="Curtains" />, url: "/shop/catalog/curtains" },
                                    { title: <FormattedMessage id="departments.mirrors" defaultMessage="Mirrors" />, url: "/shop/catalog/mirrors" }
                                ]
                            }
                        ]
                    },
                    {
                        size: 4,
                        links: [
                            {
                                title: <FormattedMessage id="departments.cleaningsupplies" defaultMessage="Cleaning Supplies" />,
                                url: "/shop/catalog/cleaning-supplies",
                                links: [
                                    { title: <FormattedMessage id="departments.vacuumcleaners" defaultMessage="Vacuum Cleaners" />, url: "/shop/catalog/vacuum-cleaners" },
                                    { title: <FormattedMessage id="departments.mopsandbuckets" defaultMessage="Mops & Buckets" />, url: "/shop/catalog/mops-buckets" },
                                    { title: <FormattedMessage id="departments.brooms" defaultMessage="Brooms" />, url: "/shop/catalog/brooms" },
                                    { title: <FormattedMessage id="departments.dustpans" defaultMessage="Dust Pans" />, url: "/shop/catalog/dust-pans" }
                                ]
                            },
                            {
                                title: <FormattedMessage id="departments.lighting" defaultMessage="Lighting" />,
                                url: "/shop/catalog/lighting",
                                links: [
                                    { title: <FormattedMessage id="departments.tablelamps" defaultMessage="Table Lamps" />, url: "/shop/catalog/table-lamps" },
                                    { title: <FormattedMessage id="departments.ceilinglights" defaultMessage="Ceiling Lights" />, url: "/shop/catalog/ceiling-lights" },
                                    { title: <FormattedMessage id="departments.floorlamps" defaultMessage="Floor Lamps" />, url: "/shop/catalog/floor-lamps" },
                                    { title: <FormattedMessage id="departments.outdoorlights" defaultMessage="Outdoor Lights" />, url: "/shop/catalog/outdoor-lights" }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    },
    
    {
        title: <FormattedMessage id="departments.petsupplies" defaultMessage="Pet Supplies" />,
        url: "",
        submenu: {
            type: "megamenu",
            menu: {
                size: "nl",
                columns: [
                    {
                        size: 6,
                        links: [
                            {
                                title: <FormattedMessage id="departments.foodandtreats" defaultMessage="Food & Treats" />,
                                url: "/shop/catalog/food-treats",
                                links: [
                                    { title: <FormattedMessage id="departments.dogfood" defaultMessage="Dog Food" />, url: "/shop/catalog/dog-food" },
                                    { title: <FormattedMessage id="departments.catfood" defaultMessage="Cat Food" />, url: "/shop/catalog/cat-food" },
                                    { title: <FormattedMessage id="departments.birdfood" defaultMessage="Bird Food" />, url: "/shop/catalog/bird-food" },
                                    { title: <FormattedMessage id="departments.smallpettreats" defaultMessage="Small Pet Treats" />, url: "/shop/catalog/small-pet-treats" }
                                ]
                            },
                            {
                                title: <FormattedMessage id="departments.pettoys" defaultMessage="Pet Toys" />,
                                url: "/shop/catalog/pet-toys",
                                links: [
                                    { title: <FormattedMessage id="departments.dogtoys" defaultMessage="Dog Toys" />, url: "/shop/catalog/dog-toys" },
                                    { title: <FormattedMessage id="departments.cattoys" defaultMessage="Cat Toys" />, url: "/shop/catalog/cat-toys" },
                                    { title: <FormattedMessage id="departments.birdtoys" defaultMessage="Bird Toys" />, url: "/shop/catalog/bird-toys" },
                                ]
                            }
                        ]
                    },
                    {
                        size: 6,
                        links: [
                            {
                                title: <FormattedMessage id="departments.petaccessories" defaultMessage="Pet Accessories" />,
                                url: "/shop/catalog/pet-accessories",
                                links: [
                                    { title: <FormattedMessage id="departments.collarsandleashes" defaultMessage="Collars & Leashes" />, url: "/shop/catalog/collars-leashes" },
                                    { title: <FormattedMessage id="departments.petbeds" defaultMessage="Pet Beds" />, url: "/shop/catalog/pet-beds" },
                                    { title: <FormattedMessage id="departments.carriersandtravel" defaultMessage="Carriers & Travel" />, url: "/shop/catalog/pet-carriers-travel" },
                                    { title: <FormattedMessage id="departments.bowlsandfeeders" defaultMessage="Bowls & Feeders" />, url: "/shop/catalog/bowls-feeders" }
                                ]
                            },
                            {
                                title: <FormattedMessage id="departments.groomingandhealth" defaultMessage="Grooming & Health" />,
                                url: "/shop/catalog/grooming-health",
                                links: [
                                    { title: <FormattedMessage id="departments.groomingtools" defaultMessage="Grooming Tools" />, url: "/shop/catalog/grooming-tools" },
                                    { title: <FormattedMessage id="departments.healthsupplements" defaultMessage="Health Supplements" />, url: "/shop/catalog/health-supplements" },
                                    { title: <FormattedMessage id="departments.cleaningsupplies" defaultMessage="Cleaning Supplies" />, url: "/shop/catalog/pet-cleaning-supplies" },
                                    { title: <FormattedMessage id="departments.litterandwastedisposal" defaultMessage="Litter & Waste Disposal" />, url: "/shop/catalog/litter-waste-disposal" }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    },
    
    {
        title: <FormattedMessage id="departments.toysandgames" defaultMessage="Toys and Games" />,
        url: "/shop/catalog/toys-and-games",
        submenu: {
            type: "megamenu",
            menu: {
                size: "nl",
                columns: [
                    {
                        size: 6,
                        links: [
                            {
                                title: <FormattedMessage id="departments.buildingsetsandblocks" defaultMessage="Building Sets & Blocks" />,
                                url: "/shop/catalog/building-sets-blocks",
                                links: [
                                    { title: <FormattedMessage id="departments.lego" defaultMessage="LEGO" />, url: "/shop/catalog/lego" },
                                    { title: <FormattedMessage id="departments.megabloks" defaultMessage="Mega Bloks" />, url: "/shop/catalog/mega-bloks" },
                                    { title: <FormattedMessage id="departments.woodenblocks" defaultMessage="Wooden Blocks" />, url: "/shop/catalog/wooden-blocks" },
                                    { title: <FormattedMessage id="departments.stemkits" defaultMessage="STEM Kits" />, url: "/shop/catalog/stem-kits" }
                                ]
                            },
                            {
                                title: <FormattedMessage id="departments.actionfiguresanddolls" defaultMessage="Action Figures & Dolls" />,
                                url: "/shop/catalog/action-figures-dolls",
                                links: [
                                    { title: <FormattedMessage id="departments.superheroes" defaultMessage="Superheroes" />, url: "/shop/catalog/superheroes" },
                                    { title: <FormattedMessage id="departments.dolls" defaultMessage="Dolls" />, url: "/shop/catalog/dolls" },
                                    { title: <FormattedMessage id="departments.collectiblefigures" defaultMessage="Collectible Figures" />, url: "/shop/catalog/collectible-figures" },
                                    { title: <FormattedMessage id="departments.plustoy" defaultMessage="Plush Toys" />, url: "/shop/catalog/plush-toys" }
                                ]
                            },

                        ],
                    },  
                    { 
                        size: 6,
                        links: [
                        {
                            title: <FormattedMessage id="departments.gamesandpuzzles" defaultMessage="Games & Puzzles" />,
                            url: "/shop/catalog/games-puzzles",
                            links: [
                                { title: <FormattedMessage id="departments.boardgames" defaultMessage="Board Games" />, url: "/shop/catalog/board-games" },
                                { title: <FormattedMessage id="departments.cardgames" defaultMessage="Card Games" />, url: "/shop/catalog/card-games" },
                                { title: <FormattedMessage id="departments.jigsawpuzzles" defaultMessage="Jigsaw Puzzles" />, url: "/shop/catalog/jigsaw-puzzles" },
                                { title: <FormattedMessage id="departments.strategygames" defaultMessage="Strategy Games" />, url: "/shop/catalog/strategy-games" }
                            ]
                        },
                        {
                            title: <FormattedMessage id="departments.outdoorplay" defaultMessage="Outdoor Play" />,
                            url: "/shop/catalog/outdoor-play",
                            links: [
                                { title: <FormattedMessage id="departments.swingsets" defaultMessage="Swing Sets" />, url: "/shop/catalog/swing-sets" },
                                { title: <FormattedMessage id="departments.playtents" defaultMessage="Play Tents" />, url: "/shop/catalog/play-tents" },
                                { title: <FormattedMessage id="departments.watertoys" defaultMessage="Water Toys" />, url: "/shop/catalog/water-toys" },
                                { title: <FormattedMessage id="departments.sportsequipment" defaultMessage="Sports Equipment" />, url: "/shop/catalog/sports-equipment" }
                            ]
                        }
                        
                    ]
                    
                    }
                    
                ]
            }
        }
    },
    
    {
        title: <FormattedMessage id="departments.toolsandhomeimprovement" defaultMessage="Tools and Home Improvement" />,
        url: "",
        submenu: {
            type: "menu",
            menu: [
                {
                    title: <FormattedMessage id="departments.solderingequipment" defaultMessage="Soldering Equipment" />,
                    url: "/shop/catalog/soldering-equipment",
                    submenu: [
                        { title: <FormattedMessage id="departments.solderingstation" defaultMessage="Soldering Station" />, url: "/shop/catalog/soldering-station" },
                        { title: <FormattedMessage id="departments.solderingdryers" defaultMessage="Soldering Dryers" />, url: "/shop/catalog/soldering-dryers" },
                        { title: <FormattedMessage id="departments.gassolderingiron" defaultMessage="Gas Soldering Iron" />, url: "/shop/catalog/gas-soldering-iron" },
                        { title: <FormattedMessage id="departments.electricsolderingiron" defaultMessage="Electric Soldering Iron" />, url: "/shop/catalog/electric-soldering-iron" }
                    ]
                },
                {
                    title: <FormattedMessage id="departments.electricallighting" defaultMessage="Electrical & Lighting" />,
                    url: "/shop/catalog/electrical-lighting",
                    submenu: [
                        { title: <FormattedMessage id="departments.lightbulbs" defaultMessage="Light Bulbs" />, url: "/shop/catalog/light-bulbs" },
                        { title: <FormattedMessage id="departments.lightfixtures" defaultMessage="Light Fixtures" />, url: "/shop/catalog/light-fixtures" },
                        { title: <FormattedMessage id="departments.warmfloor" defaultMessage="Warm Floor" />, url: "/shop/catalog/warm-floor" },
                        { title: <FormattedMessage id="departments.generators" defaultMessage="Generators" />, url: "/shop/catalog/generators" },
                        { title: <FormattedMessage id="departments.ups" defaultMessage="UPS" />, url: "/shop/catalog/ups" }
                    ]
                },
                {
                    title: <FormattedMessage id="departments.powersources" defaultMessage="Power Sources" />,
                    url: "/shop/catalog/power-sources",
                    submenu: [
                        { title: <FormattedMessage id="departments.batteries" defaultMessage="Batteries" />, url: "/shop/catalog/batteries" },
                        { title: <FormattedMessage id="departments.solarpanels" defaultMessage="Solar Panels" />, url: "/shop/catalog/solar-panels" },
                        { title: <FormattedMessage id="departments.extensioncords" defaultMessage="Extension Cords" />, url: "/shop/catalog/extension-cords" }
                    ]
                }
            ]
        }
    },
    
    {
        title: <FormattedMessage id="departments.officeproducts" defaultMessage="Office Products" />,
        url: "",
        submenu: {
            type: "menu",
            menu: [
                {
                    title: <FormattedMessage id="departments.writinganddrawing" defaultMessage="Writing & Drawing" />,
                    url: "/shop/catalog/writing-drawing",
                    submenu: [
                        { title: <FormattedMessage id="departments.pens" defaultMessage="Pens" />, url: "/shop/catalog/pens" },
                        { title: <FormattedMessage id="departments.pencils" defaultMessage="Pencils" />, url: "/shop/catalog/pencils" },
                        { title: <FormattedMessage id="departments.markers" defaultMessage="Markers" />, url: "/shop/catalog/markers" },
                        { title: <FormattedMessage id="departments.highlighters" defaultMessage="Highlighters" />, url: "/shop/catalog/highlighters" }
                    ]
                },
                {
                    title: <FormattedMessage id="departments.paperandnotebooks" defaultMessage="Paper & Notebooks" />,
                    url: "/shop/catalog/paper-notebooks",
                    submenu: [
                        { title: <FormattedMessage id="departments.notebooks" defaultMessage="Notebooks" />, url: "/shop/catalog/notebooks" },
                        { title: <FormattedMessage id="departments.printerpaper" defaultMessage="Printer Paper" />, url: "/shop/catalog/printer-paper" },
                        { title: <FormattedMessage id="departments.stickynotes" defaultMessage="Sticky Notes" />, url: "/shop/catalog/sticky-notes" },
                        { title: <FormattedMessage id="departments.journals" defaultMessage="Journals" />, url: "/shop/catalog/journals" }
                    ]
                },
                {
                    title: <FormattedMessage id="departments.officesupplies" defaultMessage="Office Supplies" />,
                    url: "/shop/catalog/office-supplies",
                    submenu: [
                        { title: <FormattedMessage id="departments.organizers" defaultMessage="Organizers" />, url: "/shop/catalog/organizers" },
                        { title: <FormattedMessage id="departments.staplers" defaultMessage="Staplers" />, url: "/shop/catalog/staplers" },
                        { title: <FormattedMessage id="departments.papierclips" defaultMessage="Paper Clips" />, url: "/shop/catalog/paper-clips" },
                        { title: <FormattedMessage id="departments.tapedispensers" defaultMessage="Tape Dispensers" />, url: "/shop/catalog/tape-dispensers" }
                    ]
                },
                {
                    title: <FormattedMessage id="departments.officeelectronics" defaultMessage="Office Electronics" />,
                    url: "/shop/catalog/office-electronics",
                    submenu: [
                        { title: <FormattedMessage id="departments.printers" defaultMessage="Printers" />, url: "/shop/catalog/printers" },
                        { title: <FormattedMessage id="departments.scanners" defaultMessage="Scanners" />, url: "/shop/catalog/scanners" },
                        { title: <FormattedMessage id="departments.laminators" defaultMessage="Laminators" />, url: "/shop/catalog/laminators" },
                        { title: <FormattedMessage id="departments.calculators" defaultMessage="Calculators" />, url: "/shop/catalog/calculators" }
                    ]
                }
            ]
        }
    },
    
    { 
        title: <FormattedMessage id="departments.sportsandoutdoors" defaultMessage="Sports and Outdoors" />,
        url: '',
        submenu: null 
    },
    { 
        title: <FormattedMessage id="departments.automotive" defaultMessage="Automotive" />,
        url: '',
        submenu: null 
    },
    { 
        title: <FormattedMessage id="departments.electronics" defaultMessage="Electronics" />,
        url: '',
        submenu: null 
    },
    { 
        title: <FormattedMessage id="departments.seasonal" defaultMessage="Seasonal" />,
        url: '',
        submenu: null 
    },
    { 
        title: <FormattedMessage id="departments.everythingelse" defaultMessage="Everything Else" />,
        url: '',
        submenu: null 
    }
];
